import { toggleDialog } from "../../utils";
import { isContactButton } from "./utils";

export const setupDesktopMenu = (
  childMenuTogglers: NodeListOf<Element>,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  for (const toggler of childMenuTogglers) {
    toggler.addEventListener("click", () => {
      if (window.matchMedia("(min-width: 1240px)").matches) {
        handleDesktopMenuClick(
          toggler,
          childMenuTogglers,
          fullPageOverlayControl,
        );
      }
    });
  }
};

const handleDesktopMenuClick = (
  toggler: Element,
  childMenuTogglers: NodeListOf<Element>,
  fullPageOverlayControl: HTMLButtonElement | null,
) => {
  // Close all other menus
  childMenuTogglers.forEach((el) => {
    el.classList.remove("title-border");
    el.setAttribute("aria-expanded", "false");
    el.nextElementSibling?.classList.add("lg:hidden");
    el.nextElementSibling?.classList.remove("lg:flex");

    if (isContactButton(el)) {
      el.classList.remove("bg-accent");
      el.classList.add("lg:bg-primary");
    }
  });

  // Toggle current menu
  if (!isContactButton(toggler)) {
    toggler.classList.toggle("title-border");
  } else {
    toggler.classList.remove("lg:bg-primary");
    toggler.classList.add("bg-accent");
  }

  toggler.nextElementSibling?.classList.remove("lg:hidden");
  toggler.nextElementSibling?.classList.add("lg:flex");
  toggler.setAttribute("aria-expanded", "true");
  toggleDialog(fullPageOverlayControl?.parentElement, true);
};

